import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import * as React from "react";
import { FileGrid } from "../../../Components/FileGrid";
import CustomLinearProgress from "../../../Components/Progress/LinearProgress";
import { useAppDataProvider } from "../../../dataprovider";

const RequestOrderFileDetail = props => {
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(props.open);
  const dataProvider = useAppDataProvider();
  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        {loading ? (
          <CustomLinearProgress loading={loading} periodTime={500} />
        ) : (
          <>
            <DialogTitle id="max-width-dialog-title"></DialogTitle>
            <DialogContent>
              <FileGrid
                source="requestorderfilerelations"
                filter={{
                  requestOrderId__eq: props.requestOrder.id.toString(),
                }}
                canRemove={false}
                showGroup={true}
                showFileType={true}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </>
        )}
      </Dialog>
    </React.Fragment>
  );
};
export default RequestOrderFileDetail;
